module.exports = __webpack_public_path__ + "img/led_strip_r1.4fa5de35.png";